import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Conta bancária", -1)
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-toggle text-subtitle text-secondary",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Ações ", -1)
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2" }, null, -1)
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = {
  key: 1,
  class: "row"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = {
  key: 0,
  class: "card bg-warning-soft"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\"><div class=\"d-flex align-items-center mb-3\"><i class=\"fa-solid fa-circle-exclamation me-2 text-warning\"></i><p class=\"mb-0 text-subtitle\">Importante</p></div><p class=\"text-paragraph\"> Só é aceito contas correntes. Não aceitamos cadastro de contas poupança ou salário. </p></div>", 1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-12 col-lg-8" }
const _hoisted_18 = { class: "col-12 col-lg-4" }
const _hoisted_19 = { class: "col-12 col-lg-8" }
const _hoisted_20 = { class: "col-12 col-lg-4" }
const _hoisted_21 = {
  key: 1,
  class: "col-12"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 col-lg-6" }
const _hoisted_24 = { class: "col-12 col-lg-6" }
const _hoisted_25 = { class: "text-paragraph" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Para alterar o tipo de conta bancária precisamos que você forneça dados adicionais. Sessões que já foram agendadas permanecerão vinculadas a sua conta atual. Somente novas sessões serão vinculadas a nova conta bancária. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: "dropdown-item text-paragraph cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleEdit && _ctx.handleEdit(...args)))
              }, _toDisplayString(_ctx.editing ? "Cancelar alteração" : "Alterar conta bancária"), 1)
            ]),
            _hoisted_7,
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: "dropdown-item text-paragraph cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChangeAccountType && _ctx.onChangeAccountType(...args)))
              }, _toDisplayString(_ctx.connectAccount?.business_type === "individual"
                  ? "Alterar para conta de pessoa jurídica"
                  : "Alterar para conta de pessoa física"), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.connectAccount)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_TextInput, {
                        readOnly: true,
                        label: "Tipo de conta",
                        value: _ctx.connectAccount?.business_type_name
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_TextInput, {
                        readOnly: true,
                        label: "Nome do titular",
                        value: _ctx.connectAccount?.legal_name
                      }, null, 8, ["value"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.editing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.editing)
                  ? (_openBlock(), _createBlock(_component_SelectInput, {
                      key: 0,
                      required: "",
                      model: _ctx.v$?.form?.bank_code,
                      options: _ctx.banks,
                      label: "Banco",
                      errorMsg: _ctx.v$.form?.bank_code.required?.$message
                    }, null, 8, ["model", "options", "errorMsg"]))
                  : (_openBlock(), _createBlock(_component_TextInput, {
                      key: 1,
                      readOnly: true,
                      label: "Banco",
                      value: _ctx.bankAccount?.bank_name
                    }, null, 8, ["value"]))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_TextInput, {
                  readOnly: !_ctx.editing,
                  label: "Agência",
                  required: "",
                  model: _ctx.v$?.form?.agencia,
                  value: _ctx.bankAccount?.agencia,
                  type: "text",
                  placeholder: "Qual a agência?",
                  errorMsg: _ctx.v$.form?.agencia.required?.$message
                }, null, 8, ["readOnly", "model", "value", "errorMsg"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_TextInput, {
                  readOnly: !_ctx.editing,
                  label: "Dígito da agência",
                  model: _ctx.v$.form?.agencia_dv,
                  value: _ctx.bankAccount?.agencia_dv,
                  type: "text",
                  placeholder: "Dígito"
                }, null, 8, ["readOnly", "model", "value"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_TextInput, {
                  readOnly: !_ctx.editing,
                  label: "Conta",
                  required: "",
                  model: _ctx.v$.form?.conta,
                  value: _ctx.bankAccount?.conta,
                  type: "text",
                  placeholder: "Qual a conta?",
                  errorMsg: _ctx.v$.form?.conta.required?.$message
                }, null, 8, ["readOnly", "model", "value", "errorMsg"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_TextInput, {
                  readOnly: !_ctx.editing,
                  label: "Dígito da conta",
                  model: _ctx.v$.form?.conta_dv,
                  value: _ctx.bankAccount?.conta_dv,
                  type: "text",
                  placeholder: "Dígito"
                }, null, 8, ["readOnly", "model", "value"])
              ]),
              (_ctx.editing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Button, {
                          label: "Cancelar",
                          color: "del",
                          onClick: _ctx.handleEdit,
                          fullWidth: ""
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_FormButton, {
                          label: "Concluir",
                          loading: _ctx.submitting,
                          disabled: _ctx.v$.$invalid,
                          class: "mb-3",
                          onOnClick: _ctx.handleUpdateBankAccount,
                          form: _ctx.v$?.form
                        }, null, 8, ["loading", "disabled", "onOnClick", "form"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      id: "update_bank_account_warning",
      title: "Importante"
    }, {
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.warning), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Continuar",
          onOnClick: _ctx.handleConfirmEdit
        }, null, 8, ["onOnClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_ModalComponent, {
      id: "update_account_type_warning",
      title: "Importante"
    }, {
      body: _withCtx(() => [
        _hoisted_26
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Continuar",
          onOnClick: _ctx.handleChangeAccountType,
          loading: _ctx.submitting
        }, null, 8, ["onOnClick", "loading"])
      ]),
      _: 1
    })
  ], 64))
}